import { useFocusEffect } from '@react-navigation/native';
import { useCallback } from 'react';

import { DRAWER_SWIPE_EDGE_WIDTH } from '../constants';

// disables drawer swipe when the screen is focused and restores it on blur
export function useDisableDrawerSwipeOnFocus(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navigation: any,
  restoreWidth: number = DRAWER_SWIPE_EDGE_WIDTH,
) {
  useFocusEffect(
    useCallback(() => {
      // get the left drawer (parent of current podcast stack navigation)
      const leftDrawer = navigation?.getParent?.();
      // get the right drawer (parent of the left drawer)
      const rightDrawer = navigation?.getParent?.()?.getParent?.();
      // disable swipe gestures on focus
      leftDrawer?.setOptions?.({ swipeEdgeWidth: 0 });
      rightDrawer?.setOptions?.({ swipeEdgeWidth: 0 });

      return () => {
        // restore swipe gestures on blur
        leftDrawer?.setOptions?.({ swipeEdgeWidth: restoreWidth });
        rightDrawer?.setOptions?.({ swipeEdgeWidth: restoreWidth });
      };
    }, [navigation, restoreWidth]),
  );
}
